import { render, staticRenderFns } from "./returnmodal.vue?vue&type=template&id=23bbf6ff&scoped=true&"
import script from "./returnmodal.vue?vue&type=script&lang=js&"
export * from "./returnmodal.vue?vue&type=script&lang=js&"
import style0 from "./returnmodal.vue?vue&type=style&index=0&id=23bbf6ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bbf6ff",
  null
  
)

export default component.exports